export default __webpack_public_path__ + "static/media/regulatory--keep-right--g2.26ef1c48.png";